import { get, put, del } from '../index'

export const getVideoList = get('/video/scroll')
export const updateVideoName = put('/video/name')
export const deleteVideo = del('/video/single')